import Vue from 'vue'
import Model from './modal.vue'

const MonitorPlayerConstructor = Vue.extend(Model)

function monitorPlayer(options = {}, onClose) {
  if (typeof onClose === 'function') {
    options.onClose = onClose
  }

  const instance = new MonitorPlayerConstructor({
    propsData: options
  })

  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
}

export default monitorPlayer
